import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAllGift,
} from "../../../../features/admin/gift_management/gift/Slice";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";

import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";
const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    setError,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        const responseData = res?.payload?.data?.data;
        reset(responseData);

        // Match the type string to the select option object
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const selectedType = watch("type");

  const onSubmit = async (data) => {
    try {
      console.log(data, "datatatat");

      const sendData = new FormData();
      sendData.append("description", data?.description);

      sendData.append("type", data?.type);
      sendData.append("booking_count", data?.booking_count || "");

      if (data?.amount) {
        sendData.append("amount", data?.amount);
      }

      sendData.append("image", data?.image[0]);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAllGift());

        setId("");

        reset({
          description: "",
          type: null,
          booking_count: "",
          amount: "",
          image: null,
        });

        clearErrors();

        setSuccess(true);
        setModalShow(true);

        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }

      if (response.payload == 406) {
        await setError("booking_count", {
          type: "manual",
          message: "Gift Already Exists",
        });
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };

  const typeOptions = [
    { value: "Transport", label: "Transport" },
    { value: "Cab", label: "Cab" },
    { value: "Share", label: "Share" },
    { value: "Customer", label: "Customer" },
  ];

  return (
    <>
      <Add_section_title title={id ? "Edit Gift" : "Add Gift "} alltotal="" />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Type</Form.Label>

                <Controller
                  name="type"
                  control={control}
                  rules={{ required: "Type is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={typeOptions}
                      placeholder="Select Type"
                      className={errors?.type ? "is-invalid" : ""}
                      onChange={(selected) => field.onChange(selected?.value)}
                      value={
                        typeOptions.find((opt) => opt.value === field.value) ||
                        null
                      }
                    />
                  )}
                />

                {errors.type && (
                  <span className="text-danger">{errors.type.message}</span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Booking Count</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Number of Booking Count"
                  {...register("booking_count", {
                    required: "Booking Count are required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.booking_count,
                  })}
                />
                {errors.booking_count && (
                  <span className="text-danger">
                    {errors.booking_count.message}
                  </span>
                )}
              </div>
            </div>

            {/* <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  Amount{" "}
                  <sub>(If Added Amount will get transfer to wallet)</sub>
                </Form.Label>

                <Form.Control
                  type="text"
                  inputMode="numeric"
                  maxLength={10}
                  placeholder="Enter Amount"
                  {...register("amount", {
                    required: "Amount is required",
                    pattern: {
                      value: /^\d{1,10}$/,
                      message: "Amount must be up to 10 digits",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                  className={classNames("", {
                    "is-invalid": errors?.amount,
                  })}
                />

                {errors.amount && (
                  <span className="text-danger">{errors.amount.message}</span>
                )}
              </div>
            </div> */}

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3} // you can increase rows as needed
                  placeholder="    Description"
                  {...register("description", {
                    required: "Description is Required",
                    maxLength: {
                      value: 400,
                      message: "Max 400 characters allowed",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.description,
                  })}
                />
                {errors.description && (
                  <span className="text-danger">
                    {errors.description?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.image,
                  })}
                  type="file"
                  {...register("image", {
                    // required: image_required
                    //   ? "Image is required"
                    //   : image_required,
                    required:
                      typeof getValues("image") == "string"
                        ? false
                        : " Image is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  //   {...register("image", {
                  //     validate: (value) => {
                  //       const currentImage = getValues("image");

                  //       if (
                  //         image_required &&
                  //         typeof currentImage !== "string" &&
                  //         (!value || value.length === 0)
                  //       ) {
                  //         return "Image is required";
                  //       }

                  //       return true;
                  //     },
                  //   })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </Form.Group>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3">
                <Form.Label className="text-center">Image Preview</Form.Label>
                {typeof getValues("image") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("image")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        reset({ name: "" });
                        setId("");
                      }}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
